module.exports = __webpack_public_path__ + "static/img/hr_visitor_card12.1b9affb7.png";